<template>
    <div class="app-body">
        <div class="a-flex-rsbc a-ptb-6">
            <span class="a-fs-16 a-fw-b">广告管理</span>
            <div class="a-flex-rcc">
                <el-button icon="el-icon-plus" type="primary"  @click="handlerAdd()">广告设置</el-button>
            </div>
        </div>
        <el-card class="el-main">
            <le-search-form @reset="handlerRest" @search="handlerSearch" :canPackUp="false" id="leSearch">
                <le-input-district-choose label="区域" 
                    :province.sync="pageParam.params.provinceCode" 
                    :city.sync="pageParam.params.cityCode" 
                    :area.sync="pageParam.params.districtCode"></le-input-district-choose>
                <le-company-under-select label="运营商户" v-model="pageParam.params.operateCompanyId"></le-company-under-select>
                <le-select-remote-search label="项目" v-model="pageParam.params.incomeId" :options="optionsincomeDistri" placeholder="请选择（可输入搜索）" />
                <le-select-remote-search label="站点" v-model="pageParam.params.stationId" :options="optionsStation" placeholder="请选择（可输入搜索）" />
                <le-select-local-search label="广告状态" multiple collapse v-model="pageParam.params.adAuthScopList" :options="adAuthScopDic" />
            </le-search-form>
            <le-pagview ref="adPage" @setData="setTableData" :pageParam="pageParam" :isFixed="true" :tableRef="$refs.adPageList">
                <el-table 
                    ref="adPageList"
                    :data="tableData" 
                    :highlight-current-row="true" 
                    v-sticky="{ top: 0, parent:'.el-card__body' }"
                    style="width: 100%">
                    <el-table-column prop="" label="站点名称" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.stationName || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="区域" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.provinceName || '-' }}-{{ row.cityName || '-' }}-{{ row.districtName || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="项目" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.incomeName || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="运营商户" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.operateCompanyName || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="广告状态" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.adAuthScop |initDic(adAuthScopDic) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="启用数量" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.startAdNum || 0 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="最后编辑人" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.updateUserName || '-' }}-{{ row.updateUserPhone || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="updateTime" label="最后编辑时间" min-width="120"></el-table-column>
                    <el-table-column prop="name" label="操作" width="80" fixed="right">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" content="广告设置" placement="top">
                                <img src="../../assets/icon/option-edit.png" class="a-wh-16" @click="handlerEdit(scope.row)" />
                            </el-tooltip>
                            <el-tooltip class="item a-ml-12" effect="dark" content="详情" placement="top">
                                <img src="../../assets/icon/option-detail.png" class="a-wh-16" @click="handlerToInfo(scope.row)" />
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </le-pagview>
        </el-card>
        <station-ad-setting ref="adSetting" @change='adSettingSuccess'></station-ad-setting>
    </div>
</template>

<script>
import util from '@/utils/util'
import stationAdSetting from './components/station-ad-setting'
export default {
    components: {
        stationAdSetting
    },
    data() {
        return {
            util,
            tableData: [],
            pageParam: {
                url: this.$Config.apiUrl.stationAdPageVoPage,
                method: "post",
                params: {
                    "adAuthScop": "",
                    adAuthScopList: [],
                    "cityCode": "",
                    "districtCode": "",
                    "incomeId": "",
                    "operateCompanyId": "",
                    "provinceCode": "",
                    "stationId": ""
                },
                freshCtrl: 1,
            },
            adAuthScopDic: [
                {
                    label: '全部开启',
                    value: '2'
                },
                {
                    label: '部分开启',
                    value: '1'
                },
                {
                    label: '全部关闭',
                    value: '0'
                }
            ],
            optionsStation: {
                url: this.$Config.apiUrl.getStationList,
                method: "post",
                params: {
                    incomeId: ''
                },
                showLoading: false,
                labelKey: "name",
                valueKey: "stationId",
                searchKey: "name",  //incomeDistriId
                pageSize: 200
            },//站点数据
            optionsincomeDistri: {
                url: this.$Config.apiUrl.incomeDistriList,
                method: "post",
                params: {},
                showLoading: false,
                labelKey: "name",
                valueKey: "id",
                searchKey: "name",
            },//项目数据
        };
    },
    mounted () {

    },  
    activated () {
		this.pageParam.freshCtrl++;
	},
    methods: {
        setTableData(data) {
            this.tableData = data;
        },
        handlerRest() {
            this.pageParam.params = {
                "adAuthScop": "",
                "cityCode": "",
                "districtCode": "",
                "incomeId": "",
                "operateCompanyId": "",
                "provinceCode": "",
                "stationId": "",
                adAuthScopList: [],
            };
            this.handlerSearch()
        },
        handlerSearch() {
            this.$refs['adPage'].pageNum = 1
            this.pageParam.freshCtrl++;
        },
        handlerEdit (datas) {
            this.$refs['adSetting'].id = datas.id
            this.$refs['adSetting'].stationId = datas.stationId
            this.$refs['adSetting'].getInfo()
        },
        adSettingSuccess () {
            this.pageParam.freshCtrl++;
        },
        handlerAdd (datas) {
            this.$router.push({
			    path: "/advertisement/advertisement-edit",
				query: {
				    id: datas ? datas.id : '',
				},
			});
        },
        handlerToInfo (datas) {
            this.$router.push({
			    path: "/advertisement/advertisement-info",
				query: {
				    id: datas ? datas.id : '',
				},
			});
        },
    },
}
</script>

<style lang="scss" scoped>

</style>
